import PropTypes from 'prop-types';
import {useState} from 'react';

const ReadMoreText = ({text = '', maxLength = 60}) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) {return null;}

  const isLong = text.length > maxLength;
  
  const displayText = expanded ? text : text.slice(0, maxLength);

  return (
    <div className={'whitespace-pre-wrap break-words text-justify'}>
      {displayText}
      {isLong && !expanded && '... '}
      {isLong && (
        <button
          onClick={() => setExpanded(!expanded)}
          className={'text-blue-500 ml-1 hover:underline focus:outline-none text-[#001529]'}
        >
          {expanded ? 'Read Less' : 'Read More'}
        </button>
      )}
    </div>
  );
};

ReadMoreText.propTypes = {
  text: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
};

export default ReadMoreText;
